"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const styles_1 = require("./styles");
const board_certification_entry_1 = __importDefault(require("./board-certification-entry"));
const messages_1 = __importDefault(require("../../lib/messages"));
const BoardCertifications = ({ board_certifications }) => {
    // do not render if data not present
    if (!board_certifications || board_certifications.length === 0) {
        return null;
    }
    return (react_1.default.createElement(styles_1.ExpertiseSectionContainer, null,
        react_1.default.createElement(styles_1.ExpertiseSectionTitle, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.boardCertificationsSectionTitle))),
        board_certifications.map((b, index) => {
            return (react_1.default.createElement(board_certification_entry_1.default, { key: `${b.board_name}${b.specialty_name}${b.year_certified}${index}`, board_certification: b }));
        })));
};
exports.default = BoardCertifications;
//# sourceMappingURL=board-certifications.js.map